import React from 'react';
import './QuotePage.css';

import { PageTitle } from '../../../components';
import { GetQuote } from '../../../sections';



const QuotePage = () => {

  return (

    <div className='quote-page'>

      {/* Page Title */}
      <PageTitle title={'Get Quote'} page={'Get Quote'} />

      {/* Get Quote Form */}
      <GetQuote />

    </div>

  );

}

export default QuotePage;